// Auto-generated normalizer for table: Turnos
export function turnosNormalize(row) {
  return {
    idTurno: row.idTurno ?? row.IdTurno ?? row['IdTurno'] ?? 0,
    clave: row.clave ?? row.Clave ?? row['Clave'] ?? '',
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    horaInicio: row.horaInicio ?? row.HoraInicio ?? row['HoraInicio'] ?? null,
    horaFin: row.horaFin ?? row.HoraFin ?? row['HoraFin'] ?? null,
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['FechaCreacion'] ?? null,
  };
}
